import { render } from "./PointRedemptionStatusSelect.vue?vue&type=template&id=28de3f44"
import script from "./PointRedemptionStatusSelect.vue?vue&type=script&lang=ts"
export * from "./PointRedemptionStatusSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script